import { createUseData } from "../../../../common/hooks/create-use-data/create-use-data";
import { service } from "./admin-accounts.service";

export const useAdminAccounts = createUseData(
    service.getAccounts,
)